import { render } from "./ModalConfirm.vue?vue&type=template&id=15aa8a9a"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"

import "./ModalConfirm.vue?vue&type=style&index=0&id=15aa8a9a&lang=css"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__